import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  createApp: {
    id: 'studio.eP31CM',
    defaultMessage: 'Create new app',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  create: {
    id: 'studio.VzzYJk',
    defaultMessage: 'Create',
  },
  createVerifyMessage: {
    id: 'studio.4M0fNr',
    defaultMessage:
      'In order to create a new organization you must first verify your email address. Refresh the page once you have verified your email.',
  },
  createOrganizationInstructions: {
    id: 'studio./liVQE',
    defaultMessage:
      'In order to create an app you must be in an organization and have the permission to create new apps. You can create one below or have someone invite you to an existing organization.',
  },
  error: {
    id: 'studio.o1JSKz',
    defaultMessage: 'Something went wrong when creating this app.',
  },
  createFailAppLimit: {
    id: 'studio.PJYOrg',
    defaultMessage:
      'Creation failed due to reaching the limit for publishing apps please upgrade your subscription or delist another app.',
  },
  name: {
    id: 'studio.HAlOn1',
    defaultMessage: 'Name',
  },
  description: {
    id: 'studio.Q8Qw5B',
    defaultMessage: 'Description',
  },
  nameConflict: {
    id: 'studio.cMpxYy',
    defaultMessage: 'An app with this name already exists in this organization.',
  },
  template: {
    id: 'studio.3JxaKs',
    defaultMessage: 'Template',
  },
  organization: {
    id: 'studio.K56Dim',
    defaultMessage: 'Organization',
  },
  resources: {
    id: 'studio.c/KktL',
    defaultMessage: 'Resources',
  },
  includeResources: {
    id: 'studio.kVS9rT',
    defaultMessage: 'Include example resources',
  },
  visibilityLabel: {
    id: 'studio.JAkIqb',
    defaultMessage: 'Visibility',
  },
  visibilityDescription: {
    id: 'studio.JMlZGy',
    defaultMessage:
      'Public apps are available in the app store. Unlisted apps aren’t listed publicly, but they are accessible using a direct link. Private apps are only visible to organization members.',
  },
  public: {
    id: 'studio.uhu5aG',
    defaultMessage: 'Public',
  },
  unlisted: {
    id: 'studio.HalL+U',
    defaultMessage: 'Unlisted',
  },
  private: {
    id: 'studio.viXE32',
    defaultMessage: 'Private',
  },
});
